export default {"src":"/_next/static/media/arrow-corner.feaf88b1.svg","height":23,"width":22,"blurWidth":0,"blurHeight":0};